// @flow

export const dataKey: 'vendingDishes' = 'vendingDishes';
